/**
 * @generated SignedSource<<cc86e89249f3f07dbae9e9cc0598244d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type progressSummary_issueViewChildIssuesPanel$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly statusField: {
        readonly status: {
          readonly statusCategory: {
            readonly statusCategoryId: string;
          };
        } | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"progressSummary_issueViewChildIssuesPanel_statusAndResolved">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "progressSummary_issueViewChildIssuesPanel";
};
export type progressSummary_issueViewChildIssuesPanel$key = {
  readonly " $data"?: progressSummary_issueViewChildIssuesPanel$data;
  readonly " $fragmentSpreads": FragmentRefs<"progressSummary_issueViewChildIssuesPanel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "progressSummary_issueViewChildIssuesPanel",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "progressSummary_issueViewChildIssuesPanel_statusAndResolved"
            },
            {
              "concreteType": "JiraStatusField",
              "kind": "LinkedField",
              "name": "statusField",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraStatus",
                  "kind": "LinkedField",
                  "name": "status",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "concreteType": "JiraStatusCategory",
                        "kind": "LinkedField",
                        "name": "statusCategory",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "statusCategoryId"
                          }
                        ]
                      },
                      "action": "LOG",
                      "path": "edges.node.statusField.status.statusCategory"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "43591b81155f2f204d1b4c1eccf446c1";

export default node;
